/** ALFX support for correlation analysis:
 *      - managing data from a correlation record
 */

export function correlationDataPoints(corrItem) {
    const corrData = corrItem?.corr_data ?? [];
    const points = corrData.map((el, i) => ({x: i, y: (el + 1) / 2}));
    return points;
}

export function correlationScore(corrItem) {
    const peakAnalysis = corrItem?.peak_analysis ?? {};
    const score = peakAnalysis.score ?? 0;
    return score;
}

export function distanceFromHydrant(corrItem, hydrant) {
    const pathBreadcrumbs = corrItem?.pathBreadcrumbs ?? {};
    const hUuid = hydrant?.uuid ?? "0"
    const hydrantData = pathBreadcrumbs[hUuid] ?? {}
    return hydrantData?.hydrant_lag_distance;
}

export function audioInfoForCorrelation(corrItem) {
    return [
        {name: "H1", url: 'https://sveltejs.github.io/assets/music/strauss.mp3'},
        {name: "H64", url: 'https://sveltejs.github.io/assets/music/strauss.mp3'}
    ]
    // const day = currentDay() - daysAgo;
    // // What about the label: Sync (uses the hydrant?) or Ens (uses the hydrant)?
    // // if (["H11", "H365", "H481"].includes(item.name ?? "")) {
    // const s3Name = "WPN2B-" + audioLabel + "-" + day.toString() + "-" + item.uuid + ".wav";
    // console.log("Audio URL: ", s3Name);
    // // const s3Name = "WPN2B-" + "314368142551501000" + "-" + "3639" + ".wav";
    // return {
    //     name: item.name ?? "",
    //     url: "https://nhmwebportal.s3.amazonaws.com/" + wpnID + "/" + s3Name
    // };
    // } else {
    //     return {
    //         name: item.name ?? "",
    //         url: 'https://sveltejs.github.io/assets/music/strauss.mp3'
    //     };
    // }
}

export function dateOptionsForCorrItem(corrItem) {
    const ts = corrItem?.rec_date ?? 0;
    return [{value: ts, title: dateMMM_DD_HH_mmForTimestamp(ts)}];
}

export function recordingDateForDisplay(ts) {
    const dateText = dateMMM_DD_HH_mmForTimestamp(ts);
    console.log(`${ts}: `, dateText);
    return dateText;
}

function dateMMM_DD_HH_mmForTimestamp(ts) {
    const date = new Date(ts * 1000);
    let formattedDate = date.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    return formattedDate;
}
